// Page for users to login

import "./Login.css";
import React from "react";
import { Form, Button, Spinner } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { getAuth, signInWithEmailAndPassword, User, setPersistence, browserSessionPersistence } from "firebase/auth";
import axios from "axios";

export default function Login() {
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);
  const history = useHistory();
  const auth = getAuth();

  const routeUser = React.useCallback(
    async (user: User) => {
      await axios.get(process.env.REACT_APP_API + "api/users/getUser/" + user.uid).then((res) => {
        // console.log(res.data);
        setIsLoading(false);
        if (res.data.role === "parent") {
          history.replace("/parent");
        } else if (res.data.role === "counselor") {
          history.replace("/counselor");
        } else if (res.data.role === "admin") {
          history.replace("/admin");
        }
      });
    },
    [history]
  );

  // Automatically sign in user if they are already logged in
  // (removed due to wanting user to sign in manually to make update sign in date in firebase console)
  // React.useEffect(() => {
  //   const unsubscribe = auth.onAuthStateChanged(async (user) => {
  //     if (user) {
  //       // console.log(user);
  //       routeUser(user);
  //     }
  //   });
  //   return unsubscribe;
  // }, [auth, routeUser]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    await setPersistence(auth, browserSessionPersistence);
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // console.log("logged in");
        routeUser(userCredential.user);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
        alert(error.code);
      });
  };

  return (
    <div className="login">
      <div className="login-form">
        <h3>Welcome Back</h3>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="Email">
            <Form.Control
              type="email"
              placeholder="Email"
              className="login-form-input"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group controlId="Password">
            <Form.Control
              type="password"
              placeholder="Password"
              className="login-form-input"
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </Form.Group>

          <Button variant="outline-primary" className="login-button" type="submit" disabled={isLoading}>
            {isLoading ? "Signing In..." : "Sign In"}
            {isLoading ? <Spinner animation="border" variant="primary" /> : null}
          </Button>
        </Form>
        <p className="fineText">To register a new camper, please sign up as "New Guardian"</p>

        <Button style={{ marginTop: 10 }} className="newuser-button" onClick={() => history.push("/signupParent")}>
          New Guardian
        </Button>
        <Button className="newuser-button" onClick={() => history.push("/signupCounselor")}>
          New Counselor
        </Button>
        <Button className="password-button" onClick={() => history.push("/resetPassword")}>
          Forgot Password?
        </Button>
      </div>
    </div>
  );
}
